export function addQueryParamToUrl(url: string, param: string, value: string) {
	const urlObj = new URL(url);
	urlObj.searchParams.append(param, value);
	return urlObj.toString();
}

export function addQueryParamToSrcset(
	srcset: string,
	param: string,
	value: string,
) {
	const newSrcsetArray: string[] = [];
	srcset.split(',').forEach((src) => {
		const splitSrc = src.trim().split(' ');
		const url = addQueryParamToUrl(splitSrc[0], param, value);
		const width = splitSrc[1];

		newSrcsetArray.push(`${url} ${width}`);
	});

	return newSrcsetArray.join(', ');
}
